export default function ($rootScope, $scope, $state, $http, $cookies, $uibModal, $timeout, $uibModalInstance, ngToast, $firebaseObject, $firebaseAuth, UtilitiesFactory, FirebaseFactory, CONFIG) {
    'ngInject';
    let utilities = UtilitiesFactory.getUtilities();
    let T = $scope.$root.T;

    $scope.pw1 = '';
    $scope.pw2 = '';

    $scope.T = $scope.$root.T;
    $scope.setControlsToDirty = utilities.forms.setControlsToDirty;
    $scope.error = "";
    $scope.isLogin = true;


    $scope.submit = () => {
        $scope.error = '';

        console.log($scope.pw1);
        FirebaseFactory.updatePassword($scope.pw1).then(() => {
            console.warn('update successful');
            ngToast.create({
                className: 'toast-success',
                content: `${T.PASSWORD} ${T.HTTP_PUT_SUCCESS_NOTIFICATION}`,
                timeout: 5000
            });
            $uibModalInstance.close();
        }, (error) => {
            console.log('error', error);
            if (error.code === "auth/requires-recent-login") {
                $scope.error = $scope.T.REQUIRES_RECENT_LOGIN;
            } else {

            }
        }).catch((error) => {
            ngToast.create({
                className: 'toast-danger',
                content: `${error}`,
                timeout: 4000
            });
            console.error('An error happened', error);
        });
    };
}



// WEBPACK FOOTER //
// ./src/app/views/app.change_password/appChangePasswordCtrl.js